import { render, staticRenderFns } from "./AppIndexAndPrevalence.vue?vue&type=template&id=34e0dbaa&scoped=true&"
import script from "./AppIndexAndPrevalence.vue?vue&type=script&lang=ts&"
export * from "./AppIndexAndPrevalence.vue?vue&type=script&lang=ts&"
import style0 from "./AppIndexAndPrevalence.vue?vue&type=style&index=0&id=34e0dbaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e0dbaa",
  null
  
)

export default component.exports